import jwtDecode from 'jwt-decode'

export function jwtDecoder( encodedAccessToken: string, jwtKey: string ): any {
	const decoded: [string, any] = jwtDecode( encodedAccessToken )
	// eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
	const entry = decoded
		? Object.entries( decoded ).find( ( obj ) => obj[ 0 ].includes( jwtKey ) )
		: undefined
	return entry?.[ 1 ] ? entry[ 1 ] : undefined
}
